import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { errorNormalizer } from '../../../../shared/Helpers/functions';
import { CustomTable } from '../../../../shared/uiComponents';
import SearchBar from '../../../../components/SearchBar';
import { ReportFilters } from '../../../Reports/helpers';
import { SoapNoteFilters } from '../../User/tableInfo';
import { Headers, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getSoapNotesAdmin } from '../../../../redux/State/clientSlice/soapNoteSlice';

const SOAPNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const direction = params.get('direction') || '';
	const orderBy = params.get('orderBy') || '';
	const searchString = params.get('search') || '';
	const status = params.get('status') || '';
	const sessionType = params.get('sessionType') || '';

	const soapNotes = useSelector((state) => state.soapNote.soapNotes);
	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.soapNote.loading);

	useEffect(() => {
		const { clientId, endDate, startDate, userId } = filterData;

		if (!startDate || !endDate) return;
		dispatch(
			getSoapNotesAdmin({
				page,
				pageSize,
				direction,
				orderBy,
				searchString,
				status,
				startDate,
				endDate,
				clientId,
				userId,
				sessionType,
			}),
		)
			.then(unwrapResult)
			.catch(errorNormalizer);
	}, [page, pageSize, direction, orderBy, searchString, status, filterData, sessionType, dispatch]);

	return (
		<>
			<ReportFilters showUsers showShorcuts={false} />
			<div style={{ display: 'flex', marginBottom: '16px' }}>
				<SearchBar hasFilter style={{ marginTop: '8px' }} />
				<SoapNoteFilters />
			</div>
			<CustomTable headers={Headers} data={soapNotes} TableBody={TableBody} loading={loading} hasMobile={false} />
		</>
	);
};

export default SOAPNotes;
